import React, { useEffect, useState } from 'react';
import { useSetRecoilState, useResetRecoilState } from 'recoil';
import { Input, Button, message, Checkbox, Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  Wrapper,
  Title,
  StyledInput,
  LoginButton,
  StyledForm,
  FormSection,
  CompanySection,
  LoginTip,
  RememberStyledForm,
  StyledPasswordInput,
} from './index.styled';
import { userAtom } from '@/recoil/atoms/user.atom';
import axiosRequest from '@/api';
import { Login as LoginType } from '@/@types/Login';
import { ResData } from '@/@types';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

function Login() {
  const [email, setEmail] = useState(localStorage.getItem('email') || '');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false); // 아이디 저장
  const setUser = useSetRecoilState(userAtom);
  const resetUser = useResetRecoilState(userAtom);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // 마운트 시 로컬스토리지에서 전에 저장해둔 email을 가져옴
  useEffect(() => {
    const savedEmail = localStorage.getItem('email');
    if (savedEmail) {
      form.setFieldsValue({ email: savedEmail });
      setRemember(true);
    }
  }, []);

  const handleLogin = async () => {
    resetUser();
    sessionStorage.removeItem('advertiserKey');

    if (remember) {
      localStorage.setItem('email', email);
    } else {
      localStorage.removeItem('email');
    }

    try {
      const response = await axiosRequest.requestAxios<ResData<LoginType>>('post', '/json_login', { email, password });
      const { access_token, role_name, category, advertiser_id } = response.data;
      console.log(response.data);
      sessionStorage.setItem('token', access_token);
      setUser({
        isAuth: true,
        token: access_token,
        role_name: role_name,
        category: category ? category : '',
        advertiser_id: advertiser_id ? advertiser_id : 0
      });
      message.success('로그인 되었습니다.');

      // 역할에 따른 리디렉션 경로 설정
      if (role_name === 'admin' || role_name === 'super') {
        navigate('/admin/dashboard');
      } else if (role_name === 'advertiser') {
        navigate('/admin/campaign');
      }
    } catch (error) {
      // 에러는 axiosRequest 모듈에서 처리되므로 여기서는 추가 처리 필요 없음
    }
  };

  const handleRememberChange = (e: CheckboxChangeEvent) => {
    setRemember(e.target.checked);
  };

  const handleSignUp = () => {
    navigate('/createaccount');
  };

  return (
    <Wrapper>
      <CompanySection>
        <div>wereward</div>
      </CompanySection>
      <FormSection>
        <Title>Welcome</Title>
        <StyledForm form={form} onFinish={handleLogin}>
          <StyledForm.Item
            name="email"
            initialValue={localStorage.getItem('email') || ''}
            rules={[
              { required: true, message: '이메일을 입력해주세요.' },
              { type: 'email', message: '올바른 이메일 형식을 입력해주세요.' },
            ]}
          >
            <StyledInput placeholder="email address" value={email} onChange={e => setEmail(e.target.value)} />
          </StyledForm.Item>
          <StyledForm.Item name="password" rules={[{ required: true, message: '비밀번호를 입력해주세요.' }]}>
            <StyledPasswordInput
              type="password"
              placeholder="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </StyledForm.Item>
          <RememberStyledForm>
            <Checkbox checked={remember} onChange={handleRememberChange}>
              Remember me
            </Checkbox>
          </RememberStyledForm>
          <StyledForm.Item>
            <LoginButton as={Button} type="primary" htmlType="submit">
              Login
            </LoginButton>
          </StyledForm.Item>
          <LoginTip onClick={handleSignUp}>회원 가입</LoginTip>
        </StyledForm>
      </FormSection>
    </Wrapper>
  );
}

export default Login;
